import angular from 'angular';
import uiRouter from 'angular-ui-router';
import flowComponent from './flow.component';

let flowModule = angular.module('app.flow', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('flow', {
      url: '/flow',
      template: '<flow></flow>'
    });
})

.component('flow', flowComponent);

export default flowModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/flow/flow.js
 **/